var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.56 53.0834H20.44C16.03 53.0834 12.81 51.24 11.5733 48.0667C10.29 44.7534 11.48 40.6467 14.56 37.87L25.3867 28L14.56 18.13C11.48 15.3534 10.29 11.2467 11.5733 7.93335C12.81 4.73669 16.03 2.91669 20.44 2.91669H35.56C39.97 2.91669 43.19 4.76002 44.4267 7.93335C45.71 11.2467 44.52 15.3534 41.44 18.13L30.6133 28L41.4633 37.87C44.52 40.6467 45.7333 44.7534 44.45 48.0667C43.19 51.24 39.97 53.0834 35.56 53.0834ZM28 30.3567L16.9167 40.4367C14.9567 42.2334 14.0933 44.8467 14.84 46.7834C15.54 48.58 17.5233 49.5834 20.44 49.5834H35.56C38.4767 49.5834 40.46 48.6034 41.16 46.7834C41.9067 44.8467 41.0667 42.2334 39.0833 40.4367L28 30.3567ZM20.44 6.41669C17.5233 6.41669 15.54 7.39669 14.84 9.21669C14.0933 11.1534 14.9333 13.7667 16.9167 15.5634L28 25.6434L39.0833 15.5634C41.0433 13.7667 41.9067 11.1534 41.16 9.21669C40.46 7.42002 38.4767 6.41669 35.56 6.41669H20.44Z",
    fill: "#565656"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.a1a1cfb32ea377bc9b16370ed13ac371.svg";
export { ForwardRef as ReactComponent };